export function isResultType(value: unknown): value is { ok: unknown; err: unknown } {
	if (typeof value === 'object' && !Array.isArray(value) && value !== null && 'ok' in value && 'err' in value) {
		return true;
	}

	return false;
}

export function isPromise(value: unknown): value is Promise<unknown> {
	return typeof value === 'object' && !Array.isArray(value) && value !== null && 'then' in value;
}

export function isBoolean(value: unknown): value is boolean {
	return typeof value === 'boolean';
}

export function isString(value: unknown): value is string {
	return typeof value === 'string';
}

export function isError(value: unknown): value is Error {
	return value instanceof Error;
}

// eslint-disable-next-line @typescript-eslint/ban-types
// biome-ignore lint/complexity/noBannedTypes: suppressed due to migration - should be fixed
export function isFunction(value: unknown): value is Function {
	return typeof value === 'function';
}
